import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase/config";
import { PUMA_FAMILY_COLLECTION } from "../services/pumaFamilyRequests";
import { useLoaderData } from "react-router-dom";
import ExportTableAsCSV from "../components/ExportTableAsCSV";

function PumaFamily2026Requests() {
  const usersList = [];
  const result = useLoaderData(pumaFamily2026RequestsLoader);

  result.forEach((doc) => {
    usersList.push({ id: doc.id, ...doc.data() });
  });

  return (
    <div className="container py-8 mx-auto">
      <ExportTableAsCSV
        tableData={document.querySelector(".pumaGetInTouchTable")}
        fileName="Puma_Family_2026_Requests.csv"
      />
      <div className="grid grid-cols-6 gap-0 p-2 text-white bg-fordBlue pumaGetInTouchTable">
        <h4 className="col-span-1">Име</h4>
        <h4 className="col-span-1 text-center">Имейл</h4>
        <h4 className="col-span-1 text-center">Телефон</h4>
        <h4 className="text-center">Представителство</h4>
        <h4 className="text-center">Модел</h4>
        <h4 className="text-center ">Дата</h4>
      </div>
      {usersList &&
        usersList.map((user) => (
          <div
            className="grid grid-cols-6 gap-2 p-2 border-b text-fordBlue even:bg-gray-50 hover:bg-gray-200 offerTableRow"
            key={user.id}
          >
            <p className="col-span-1">{user.name}</p>
            <p className="col-span-1 text-center">{user.email}</p>
            <p className="col-span-1 text-center">{user.phone}</p>
            <p className="text-center ">{user.dealershipLabel || user.dealership}</p>
            <p className="text-center ">{user.model}</p>
            <p className="text-center ">
              {user.date?.toDate?.().toLocaleString("bg-BG") || "—"}
            </p>
          </div>
        ))}
    </div>
  );
}

export default PumaFamily2026Requests;

export const pumaFamily2026RequestsLoader = async () => {
  return getDocs(query(collection(db, PUMA_FAMILY_COLLECTION), orderBy("date", "desc")));
};
